import React, { Component } from 'react';
import { FormGroup, ControlLabel, Col, FormControl, HelpBlock } from 'react-bootstrap';
import { UnControlled as CodeMirror } from 'react-codemirror2';

import { ContextMenu, Item, ContextMenuProvider, Separator } from 'react-contexify';


require('codemirror/mode/htmlembedded/htmlembedded');
require('codemirror/mode/css/css');
require('codemirror/mode/javascript/javascript');
require('codemirror/addon/hint/show-hint');
require('codemirror/addon/hint/css-hint');
require('codemirror/addon/hint/html-hint');
require('codemirror/addon/hint/xml-hint');
require('codemirror/addon/hint/javascript-hint');

require('../../utils/helpers/cm_auto_refresh/');


export default class InputField extends Component {

  state = { editor: {} }
  
  handleChange(editor, data, value) {
    const { input } = this.props;
    input.onChange(value);
  }

  handleKeyPress(cmInstance, event) {
    const { insertItems } = this.props;
    const CdMirror = cmInstance.constructor;
    if (event.key === '{') {
      cmInstance.showHint({
        closeCharacters: /[\s()[\];:>,]/,
        hint: (editor, options) => {
          const word = options & options.word || /[$]+/g;
          const cur = editor.getCursor();
          const curLine = editor.getLine(cur.line);
          let start = cur.ch;
          let end = start;
          while (end < curLine.length && word.test(curLine.charAt(end))) ++end;
          while (start && word.test(curLine.charAt(start - 1))) --start;
          return {
            list: insertItems || [],
            from: CdMirror.Pos(cur.line, start - 1),
            to: CdMirror.Pos(cur.line, end)
          };
        }
      });
    }
  }

  handlePaste(e, refs, data) {
    const { editor, text } = data;
    const selection = editor.getSelection();
    if (selection.length > 0) {
      editor.replaceSelection(text);
    } else {
      const cursor = editor.doc.getCursor();
      const pos = {
        line: cursor.line,
        ch: cursor.ch
      };
      editor.doc.replaceRange(text, pos);
    }
  }

  render() {
    const {  
      input, 
      meta: { error, touched }, 
      label, 
      id,
      options, 
      layout,
      insertItems,
      mode,
      idName,
      disabled,
    } = this.props;

    const { editor } = this.state;

    const showError = error && touched;
    const defaultOpts = {
      mode: mode || 'htmlembedded',
      lineNumbers: true,
      theme: 'material',
      autoRefresh: { force: true },
      readOnly: disabled || false,
    };
    
    const opts = options || {};
    
    const inputBlock = () => {
      return (
        <div>
          {insertItems.length > 0 ? <ContextMenu 
            id={`codemirrorContext${idName}`}
            theme='dark'
          >
             <Item disabled>
              Select Options to Insert
             </Item>
             <Separator />
            {insertItems.map((item, i) => {
              return (
                <Item 
                  data={{ editor, text: item.text }} 
                  onClick={this.handlePaste.bind(this)}
                  key={`sub-${i}`}
                >
                  {item.displayText}
                </Item>
              );
            })}
          </ContextMenu> : null }
          <ContextMenuProvider
            id={`codemirrorContext${idName}`}
          >
            <div className={disabled ? 'disabled-div' : ''}>
              <CodeMirror
                value={input.value} 
                onChange={this.handleChange.bind(this)} 
                options={{ ...defaultOpts, opts }}
                autoCursor={false}
                autoScroll={false}
                onKeyPress={this.handleKeyPress.bind(this)}
                editorDidMount={(e) => this.setState({ editor: e })}
              />
            </div>
          </ContextMenuProvider>
          <FormControl.Feedback />
          <HelpBlock>{showError ? error : ''}</HelpBlock>
        </div>
      );
    };

    if (layout === 'horizontal') {
      return (
        <FormGroup controlId={id || input.name} validationState={showError ? 'error' : null}>
          <Col componentClass={ControlLabel} xs={3} className='control-label-horizontal'>
            {label}
          </Col>
          <Col xs={9}>
            {inputBlock()}
          </Col>
        </FormGroup>
      );
    }

    return (  
      <FormGroup 
        controlId={id || input.name} 
        className={label ? 'label-present' : 'label-blank'} 
        validationState={showError ? 'error' : null}
      > 
        {label ? <ControlLabel>{label}</ControlLabel> : ''}
        {inputBlock()}
      </FormGroup>
    );
  }
}
